import { DATA_METRICS } from '../componentKeys.js'

const identifiers = {
  key: 'uploadedDncProspects',
  type: 'call',
  access: 'stats',
}

const formatting = {
  format: {
    title: 'Uploaded DNC Prospects',
  },
}

const keys = {
  statKey: 'uploaded_dnc_prospects',
  componentKeys: [DATA_METRICS],
  healthKey: 'metric_health',
}

const calculation = {
  calcType: 'aggregate',
}

const uploadedDncProspects = {
  metaData: Object.assign(identifiers, formatting, keys, calculation),
  calculationConfig: calculation,
}

export { uploadedDncProspects }
